import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from "reactstrap";
import ReactTooltip from "react-tooltip";
import { getTranslate } from "react-localize-redux";
import axios from "axios";
import moment from "moment";
import { EditConfigReport } from "../configuredReports/editConfigReport";
import {
  reportActions,
  configActions,
  msgActions,
} from "../../../../redux/actions";
import { getReportData } from "../../../../utils";
import "./ConfigReportsGrid.css";

class ConfigReportsGrid extends React.Component {
  state = { pastNextLaunchConfirmModal: false };

  onEditClick = async (event, report, repDescObjRef) => {
    event.preventDefault();
    // show model wizard
    const { dispatch } = this.props;
    try {
      const params = {
        DefinitionId: report._id,
        customerId: report.customerId,
      };
      const response = await axios.get("Reporting/Definitions/GetById", { params });
      var json = response.data;
      if (json.Errors && json.Errors.length > 0) {
        dispatch(msgActions.error("Get Report Definition", json.Errors[0]));
        return;
      }
      let selectedReport = JSON.parse(JSON.stringify(report));
      delete selectedReport.isActive;
      const _report = json.Data || selectedReport;
      dispatch(reportActions.setSelectedReportEdit(_report));
      dispatch(reportActions.setSelectedReportEditIsActive(_report.active));
      dispatch(
        reportActions.setSelectedReportEditIsInternalUse(!!_report.internalUse)
      );
      dispatch(
        configActions.toggleEditConfigReportModal(true, _report, repDescObjRef)
      );
    } catch (error) {
      dispatch(msgActions.error("Get Report Definition", error.message));
    }
  };

  onViewExecutedReportsClick(event, report) {
    event.preventDefault();
    // use history to map to the exec report view
    let qData = {
      config_report_id: report._id,
    };
    var qs = require("qs");
    this.props.history.push("/exec-reports?" + qs.stringify(qData));
  }

  handleRowClick = (event, index) => {
    event.preventDefault();
    var sel = getSelection().toString();
    if (!sel) {
      if (this.props.reportName === "customerConfiguredReports") {
        this.props.dispatch(configActions.setActiveConfigReportRow(index));
      } else {
        this.props.dispatch(
          reportActions.setActiveRow("configuredReports", index)
        );
      }
    }
  };

  generateReportGrid = (reports) => {
    const { translate, isExternalUser, reportsDescriptions } = this.props;
    if (reports.length === 0) {
      return (
        <div className="empty-text">
          <p>{translate("NoConfiguredReportMsg")}</p>
        </div>
      );
    }
    const { showCustomerColumn } = this.props;
    var table_html = [];
    var me = this;
    var _repDescJson = reportsDescriptions || [];
    reports.forEach((report, index) => {
      var _repDescObjRef =
        _repDescJson.find((obj) => {
          return obj.reporttemplatename === report.reportPipelineDefinitionId;
          //return obj.triggertype === report.triggerType;
        }) || {};

      /* var _inputData = {};
			if (report.reportDefComponentsParams && report.reportDefComponentsParams.length) {
				_inputData =
					report.reportDefComponentsParams[0] &&
					report.reportDefComponentsParams[0].data &&
					report.reportDefComponentsParams[0].data.scriptparams &&
					report.reportDefComponentsParams[0].data.scriptparams.inputData;
			} */
      table_html.push(
        <tr
          key={index}
          className={
            "row_tr finger w_p_action " +
            (report.mode === "test" ? " mode_color" : "") +
            (report.isActive ? " active-row" : "")
          }
          onClick={(e) => {
            me.handleRowClick(e, index);
          }}
        >
          {showCustomerColumn && !isExternalUser && (
            <td className="text-center">{report.customer}</td>
          )}
          <td className="text-center">
            {report.triggerCriteria &&
              (report.triggerCriteria.Project ||
                report.triggerCriteria.project)}
          </td>
          <td className="text-center">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "left",
                  width: "300px",
                }}
              >
                {report.reportName && (
                  <div>
                    <b>{translate("Name")}:</b> {report.reportName}
                  </div>
                )}
                <div>
                  <b>{translate("Report Type")}:</b>{" "}
                  {_repDescObjRef
                    ? _repDescObjRef.reportvisiblename ||
                      report.reportPipelineDefinitionId
                    : report.triggerType === "downloadData"
                    ? "FileDoc downloading report"
                    : report.reportPipelineDefinitionId}
                </div>
              </div>
            </div>
          </td>
          <td
            className="text-center"
            style={{
              padding: "0.3rem 1.9rem",
              width: "260px",
              height: "50px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {report.triggerType && [
                <span
                  key={"reportType-" + index}
                  className={
                    "fa fa-" +
                    (report.triggerType === "recurringreport"
                      ? "clock"
                      : "bolt")
                  }
                  style={{
                    fontSize: "2em",
                    marginRight: "1rem",
                    width: "24px",
                  }}
                />,
                <div
                  key={"reportTypeContent-" + index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "left",
                  }}
                >
                  {report.triggerType === "recurringreport" &&
                    report.schedules &&
                    report.schedules[0] && [
                      <div key="lastlaunch" style={{ marginBottom: "3px" }}>
                        Last launch:{" "}
                        {report.schedules[0].lastlaunch
                          ? moment
                              .utc(
                                report.schedules[0].lastlaunch,
                                moment.ISO_8601
                              )
                              .format("DD-MM-YYYY HH:mm")
                          : "n/a"}
                      </div>,
                      <div key="nextlaunch" style={{ marginBottom: "3px" }}>
                        Next launch:{" "}
                        {report.schedules[0].nextlaunch
                          ? moment
                              .utc(
                                report.schedules[0].nextlaunch,
                                moment.ISO_8601
                              )
                              .format("DD-MM-YYYY HH:mm")
                          : "n/a"}
                      </div>,
                      <div key="scheduletype">
                        Repeat:{" "}
                        {report.schedules[0].type
                          ? report.schedules[0].type
                          : "n/a"}
                      </div>,
                    ]}
                  {report.triggerType === "fibfinalized" && (
                    <div>{translate("File delivery event")}</div>
                  )}
                  {report.triggerType === "fibchannelfinalized" && (
                    <div>{translate("Channel closed event")}</div>
                  )}
                  {report.triggerType === "fibfilearrived" && (
                    <div>{translate("File arrival event")}</div>
                  )}
                  {report.triggerType === "batchdelivered" && (
                    <div>{translate("Batch delivery event")}</div>
                  )}
                </div>,
              ]}
            </div>
          </td>
          <td className="text-center">
            {/* {_inputData && (_inputData.run || _inputData.Run) ? (
							_inputData.run || _inputData.Run
						) : (
							report.triggerCriteria && (report.triggerCriteria.Run || report.triggerCriteria.run)
						)} */}
            {report.triggerCriteria &&
              (report.triggerCriteria.Run || report.triggerCriteria.run)}
          </td>
          <td className="text-center">
            {report.active && (
              <div className="customer-state active-state">
                <span className="fa fa-check-circle" />
                <span className="customer-serial">{translate("Active")}</span>
              </div>
            )}
            {!report.active && (
              <div className="customer-state inactive-state">
                <span className="fa fa-ban" />
                <span className="customer-serial">{translate("Inactive")}</span>
              </div>
            )}
          </td>
          <td
            className="text-center"
            style={{ padding: "0.3rem 0.9rem", width: "380px" }}
          >
            {(!isExternalUser ||
              (isExternalUser && !!_repDescObjRef?.visibleForExternal)) && (
              <Button
                color="primary"
                style={{ marginRight: "7px" }}
                onClick={(e) => {
                  this.onEditClick(e, report, _repDescObjRef);
                }}
              >
                <span>{translate("Edit")}</span>
              </Button>
            )}
            <Button
              color="secondary"
              className="switchBtn"
              onClick={(e) => {
                this.onViewExecutedReportsClick(e, report);
              }}
            >
              <span>{translate("View executed reports")}</span>
            </Button>
          </td>
        </tr>
      );
    });

    return (
      <div className="col-12" style={{ padding: "0px" }}>
        <div className="row" style={{ margin: "0px" }}>
          <table
            className="table-bordered table-condensed cf table-hover table-sm panel-default col-12 col-lg-offset-0"
            cellSpacing="0"
            style={{ border: "0px", padding: "0px" }}
          >
            <thead
              style={{ background: "#3A4A57", color: "#fff" }}
              className="grids_header"
            >
              <tr style={{ fontSize: ".8rem" }}>
                {showCustomerColumn && !isExternalUser && (
                  <th className="text-center">{translate("Customer")}</th>
                )}
                <th className="text-center">{translate("Project")}</th>
                <th className="text-center">{translate("Report name")}</th>
                <th className="text-center">
                  {translate("Trigger")}{" "}
                  <>
                    <button
                      className="btn btn-default btn-circle btn-secondary"
                      style={{
                        width: "18px",
                        height: "18px",
                        margin: "0px 0px 0px 0.5em",
                        padding: 0,
                      }}
                      data-tip
                      data-place="bottom"
                      data-type="info"
                      data-effect="solid"
                      data-for={`trigger-tooltip`}
                    >
                      <i
                        className="fa fa-exclamation"
                        style={{
                          fontSize: "0.9em",
                        }}
                      />
                    </button>
                    <ReactTooltip
                      className="customeTheme"
                      id={`trigger-tooltip`}
                    >
                      <div style={{ textTransform: "none", textAlign: "left" }}>
                        {translate("TriggerSchedulesToolTip")}
                      </div>
                    </ReactTooltip>
                  </>
                </th>
                <th className="text-center">{translate("Run")}</th>
                <th className="text-center">{translate("Status")}</th>
                <th className="text-center">{translate("Actions")}</th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: "#fff", fontSize: "12px" }}>
              {table_html}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  handleFormSave = (data, selectedReportType, reportForEdit) => {
    let reportData = getReportData(data, selectedReportType, {
      ...JSON.parse(JSON.stringify(reportForEdit)),
      active: this.props.selectedReportEditIsActive,
      internalUse: this.props.selectedReportEditIsInternalUse,
    });
    if (
      reportData.validationErrorMsgs &&
      reportData.validationErrorMsgs.length
    ) {
      this.props.dispatch(
        msgActions.error(
          "Validation Error",
          <ListGroup>
            {reportData.validationErrorMsgs.map((item, index) => (
              <ListGroupItem
                key={index}
                //color="danger"
                dangerouslySetInnerHTML={{
                  __html: item,
                }}
              />
            ))}
          </ListGroup>
        )
      );
    } else if (reportData.schedulesConfirmRequired) {
      this.setState({
        pastNextLaunchConfirmModal: true,
        reportDataToBeSaved: reportData.data,
      });
    } else {
      this.saveReport(reportData.data);
    }
  };

  saveReport = (params) => {
    let updateDefinition = false;
    let updateSchedule = false;

    const originalDefinitionParams = Object.assign(
      {},
      this.props.selectedReportEdit
    );
    delete originalDefinitionParams["schedules"];

    const definitionParams = Object.assign({}, params);
    delete definitionParams["schedules"];

    updateDefinition =
      JSON.stringify(originalDefinitionParams) !==
      JSON.stringify(definitionParams);

    // call update schudules if triggerType === "recurringreport"
    let schedulesParams;
    if (
      params.triggerType === "recurringreport" &&
      params.schedules &&
      params.schedules[0]
    ) {
      const originalSchedulesParams = Object.assign(
        {},
        this.props.selectedReportEdit.schedules[0],
        {
          state: this.props.selectedReportEdit.active ? "Pending" : "Canceled",
        }
      );

      schedulesParams = Object.assign({}, params.schedules[0], {
        //reportdefinitionid: response.data.Data["_id"],
        state: params.active ? "Pending" : "Canceled",
      });
      updateSchedule =
        JSON.stringify(originalSchedulesParams) !==
        JSON.stringify(schedulesParams);
    }

    if (updateDefinition) {
      this.updateDefinition(
        definitionParams,
        updateSchedule,
        schedulesParams,
        params
      );
    } else if (updateSchedule) {
      this.updateSchedule(schedulesParams, params);
    } else {
      this.props.dispatch(
        msgActions.error("Report Update", "Nothing to update")
      );
    }

    if (updateDefinition || updateSchedule) {
      this.props.dispatch(
        reportActions.setSelectedReportEdit(JSON.parse(JSON.stringify(params)))
      );
    }
  };

  updateDefinition = (
    definitionParams,
    updateSchedule,
    schedulesParams,
    orgParams
  ) => {
    axios
      .put("Reporting/Definitions/Update", definitionParams)
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          this.props.dispatch(
            msgActions.error(
              "Report Update",
              <>
                <p>Server failed with the following errors:</p>
                {response.data.Errors.join("<br />")}
              </>
            )
          );
        } else {
          if (
            response.data.ValidationErrors &&
            response.data.ValidationErrors.length
          ) {
            this.props.dispatch(
              msgActions.error(
                "Validation Error",
                <>
                  <p>The following field(s) are missed:</p>
                  {response.data.ValidationErrors.join("<br />")}
                </>
              )
            );
          } else if (updateSchedule) {
            this.updateSchedule(schedulesParams, orgParams);
          } else {
            // reload and close window
            this.props.dispatch(
              msgActions.success("Report Update", "Report updated successfully")
            );
            /* this.props.dispatch(configActions.toggleEditConfigReportModal(true, orgParams)); */
            this.props.handlePageReload();
          }
        }
      });
  };

  updateSchedule = (schedulesParams, orgParams) => {
    axios
      .put("Reporting/Schedules/Update", { Data: schedulesParams })
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          this.props.dispatch(
            msgActions.error(
              "Server Error",
              <>
                <p>Server failed with the following errors:</p>
                {response.data.Errors.join("<br />")}
              </>
            )
          );
        } else {
          // reload and close window
          this.props.dispatch(
            msgActions.success("Report Update", "Report updated successfully")
          );
          this.props.dispatch(
            configActions.toggleEditConfigReportModal(true, orgParams)
          );
          this.props.handlePageReload();
        }
      });
  };

  handleActiveChange = () => {
    this.props.dispatch(
      reportActions.setSelectedReportEditIsActive(
        !this.props.selectedReportEditIsActive
      )
    );
  };

  handleInternalUseChange = () => {
    this.props.dispatch(
      reportActions.setSelectedReportEditIsInternalUse(
        !this.props.selectedReportEditIsInternalUse
      )
    );
  };

  togglePastNextLaunchConfirmModal = () => {
    this.setState({
      pastNextLaunchConfirmModal: !this.state.pastNextLaunchConfirmModal,
    });
  };
  handleYesConfirmNextLaunchDialog = () => {
    this.saveReport(this.state.reportDataToBeSaved);
    this.setState({
      pastNextLaunchConfirmModal: false,
      reportDataToBeSaved: null,
    });
  };
  handleNoConfirmNextLaunchDialog = () => {
    this.setState({
      pastNextLaunchConfirmModal: false,
      reportDataToBeSaved: null,
    });
  };

  /* toggleMsgBox = () => {
		if (this.state.resetLoader) this.state.resetLoader();
		this.setState({
			msg: {},
			pastNextLaunchConfirmModal: false,
			reportDataToBeSaved: null,
			resetLoader: null
		});
	}; */

  render() {
    const {
      reports,
      handlePageClick,
      handleFirstClick,
      PageNumber,
      prev,
      last,
      pageNumbers,
      translate,
    } = this.props;

    return (
      <div
        className="content_block fill col-lg-12 col-md-12 col-sm-12 col-xs-12"
        style={{ padding: "0", width: "100%" }}
      >
        <div>{reports && this.generateReportGrid(reports)}</div>

        {reports && reports.length > 0 && (
          <div className="d-flex justify-content-center grid-footer">
            {/* <FormGroup className="mb-2 mr-sm-2 mb-sm-0 form-inline paging-count-select" /> */}
            <Pagination>
              <PaginationItem>
                {prev === 0 ? (
                  <PaginationLink disabled>
                    <small>
                      <span className="fa fa-fast-backward" />
                    </small>
                    &nbsp;{translate("First")}
                  </PaginationLink>
                ) : (
                  <PaginationLink
                    onClick={handleFirstClick}
                    id={prev}
                    href={prev}
                  >
                    <small>
                      <span className="fa fa-fast-backward" />
                    </small>
                    &nbsp;{translate("First")}
                  </PaginationLink>
                )}
              </PaginationItem>
              <PaginationItem>
                {prev === 0 ? (
                  <PaginationLink disabled>
                    <small>
                      <span className="fa fa-backward" />
                    </small>
                    &nbsp;{translate("Prev")}
                  </PaginationLink>
                ) : (
                  <PaginationLink
                    onClick={handlePageClick}
                    id={prev}
                    href={prev}
                  >
                    <small>
                      <span className="fa fa-backward" />
                    </small>
                    &nbsp;{translate("Prev")}
                  </PaginationLink>
                )}
              </PaginationItem>
              {pageNumbers.map((number, i) => (
                <Pagination key={i}>
                  <PaginationItem
                    active={
                      pageNumbers.indexOf(PageNumber) === i ? true : false
                    }
                  >
                    <PaginationLink
                      onClick={handlePageClick}
                      href={number}
                      key={number}
                      id={number}
                    >
                      {number}
                    </PaginationLink>
                  </PaginationItem>
                </Pagination>
              ))}

              <PaginationItem>
                {PageNumber >= last ? (
                  <PaginationLink disabled>
                    {translate("Next")}&nbsp;
                    <small>
                      <span className="fa fa-forward" />
                    </small>
                  </PaginationLink>
                ) : (
                  <PaginationLink
                    onClick={handlePageClick}
                    id={pageNumbers[pageNumbers.indexOf(PageNumber) + 1]}
                    href={pageNumbers[pageNumbers.indexOf(PageNumber) + 1]}
                  >
                    {translate("Next")}&nbsp;
                    <small>
                      <span className="fa fa-forward" />
                    </small>
                  </PaginationLink>
                )}
              </PaginationItem>
            </Pagination>
            {/* <div className="grid-paging-info" style={{ margin: "0px 15px" }}>
              Version: {window.NTT && window.NTT.version}
            </div> */}
          </div>
        )}
        <EditConfigReport
          reportDefinitionId={this.props.selectedReportEdit._id}
          reportPipelineDefinitionId={
            this.props.selectedReportEdit.reportPipelineDefinitionId
          }
          handleFormSave={this.handleFormSave}
          handleActiveChange={this.handleActiveChange}
          isActive={this.props.selectedReportEditIsActive}
          handleInternalUseChange={this.handleInternalUseChange}
          internalUse={this.props.selectedReportEditIsInternalUse}
          handlePageReload={this.props.handlePageReload}
        />
        <Modal
          isOpen={this.state.pastNextLaunchConfirmModal}
          toggle={this.togglePastNextLaunchConfirmModal}
        >
          <ModalHeader toggle={this.togglePastNextLaunchConfirmModal}>
            {translate("ScheduleNextLaunchWarning")}
          </ModalHeader>
          <ModalBody>
            <Alert color="warning">
              You choose a date in a past for scheduled reports. That will
              launch a generation and delivery of all the reports from the day
              you specified till current day.
              <br />
              This could lead to spamming recipients of e-mails and uploading a
              lot of files to SFTP/FTP connections.
              <br />
              Do you really want to set the date in the past?
            </Alert>
          </ModalBody>
          <ModalFooter className="text-center">
            <Button
              color="secondary"
              style={{ width: "90px" }}
              onClick={this.handleYesConfirmNextLaunchDialog}
            >
              Yes
            </Button>
            <Button
              color="primary"
              className="EventSearchSubmit"
              style={{ marginLeft: "60px", width: "90px" }}
              onClick={this.handleNoConfirmNextLaunchDialog}
            >
              No
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    config: { reportsDescriptions },
    locale,
    reports: {
      selectedReportEdit,
      selectedReportEditIsActive,
      selectedReportEditIsInternalUse,
    },
  } = state;
  return {
    reportsDescriptions,
    selectedReportEdit,
    selectedReportEditIsActive,
    selectedReportEditIsInternalUse,
    translate: getTranslate(locale),
  };
}

const connectedConfigReportsGrid = connect(mapStateToProps)(
  withRouter(ConfigReportsGrid)
);
export { connectedConfigReportsGrid as ConfigReportsGrid };
